import * as React from 'react';
import { getClassName } from '../../util/string-util';
import './Button.scss';

export const Button = ({ ref, className, primary, fullWidth, ...props }: IButtonProps) => (
  <button
    className={getClassName('button', className, primary && 'primary', fullWidth && 'full-width')}
    {...props}
  />
);

interface IButtonProps
  extends React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    > {
  primary?: boolean;
  fullWidth?: boolean;
}

export const ButtonContainer: React.SFC<IButtonContainerProps> = ({
  className,
  align,
  ...props
}) => <div className={getClassName('button-container', className, align)} {...props} />;

interface IButtonContainerProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  align?: 'left' | 'right';
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.tsx